import { ScheduledRequestsApi } from '../../generated/new';

const scheduledRequestsApi = new ScheduledRequestsApi();

export default scheduledRequestsApi;
